export default __webpack_public_path__ + "288325c.png";